"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportBusinessResponseToJSON = exports.ImportBusinessResponseFromJSONTyped = exports.ImportBusinessResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ImportBusinessResponseFromJSON(json) {
    return ImportBusinessResponseFromJSONTyped(json, false);
}
exports.ImportBusinessResponseFromJSON = ImportBusinessResponseFromJSON;
function ImportBusinessResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'results': !(0, runtime_1.exists)(json, 'results') ? undefined : (json['results'].map(_1.ImportBusinessResponseItemFromJSON)),
    };
}
exports.ImportBusinessResponseFromJSONTyped = ImportBusinessResponseFromJSONTyped;
function ImportBusinessResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'results': value.results === undefined ? undefined : (value.results.map(_1.ImportBusinessResponseItemToJSON)),
    };
}
exports.ImportBusinessResponseToJSON = ImportBusinessResponseToJSON;
